import React, {useEffect, useState} from "react";
import PatientOverwiev from "./PatientOverview";
import {Button, Col, Container, Row, Image} from "react-bootstrap";
import Timer from "./Timer";
import recordVoice from "./RecordVoice";
import RecordVoice from "./RecordVoice";
import {useLocation, useNavigate} from "react-router-dom";
import ShowImagePage from "./ShowImagePage";
import Recording from "./Recording";
import ValencePage from './ValencePage';
import ArousalPage from './ArousalPage';


interface ImagePageProps {
    languageData: any;
}

const ImagePage : React.FC<ImagePageProps> = ({languageData}) => {
    const [timer, setTimer] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const username = params.get('username');
    const [isFinished, setIsFinished] = useState(false);
    const [selectedImage, setSelectedImage] = useState<string>("");
    const [showValence, setShowValence] = useState(false);
    const [valenceRating, setValenceRating] = useState<number | null>(null);
    const [showArousal, setShowArousal] = useState(false);
    const [arousalRating, setArousalRating] = useState<number | null>(null);
    const [showRecording, setShowRecording] = useState(false);
    const [recordingFinished, setRecordingFinished] = useState(false);

    const showImage = () => {
        setTimer(true);
        setButtonClicked(true);
    }

    const handleTimerFinish = () => {
        setIsFinished(true);
        setShowValence(true);
    }

    const handleImageFinish = (image: string) => {
        setSelectedImage(image);
    }

    const handleValenceFinish = (value: number) => {
        setValenceRating(value);
        setShowValence(false);
        setShowArousal(true);
    }

    const handleArousalFinish = (value: number) => {
        setArousalRating(value);
        setShowArousal(false);
        setShowRecording(true);
    }

    const handleRecordingFinish = () => {
        setRecordingFinished(true);
        navigate(`/?username=${username}`);
    }

    // Generate the recording identifier with ratings
    const getRecordingIdentifier = () => {
        if (valenceRating !== null && arousalRating !== null) {
            return `${selectedImage}_valence${valenceRating}_arousal${arousalRating}`;
        }
        return selectedImage;
    }

    return(
        <Container className="p-5">
            <Row style={{marginTop : "10%"}}>
                <Col></Col>
                <Col>
                    <Button style={{width : "100%"}} onClick={() => showImage()} disabled={buttonClicked} hidden={isFinished}>Start</Button>
                    {(timer && !isFinished) && (
                        <Timer initialTime={10} onFinish={handleTimerFinish}/>
                    )}
                </Col>
                <Col></Col>
            </Row>
            <Row className="justify-content-center g-0">
                <Col xs={12} md={10} lg={8} className="px-0"> 
                    {(buttonClicked && !isFinished) && (
                        <ShowImagePage username={username} onFinish={handleImageFinish}/>
                    )}
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}> 
                    {showValence && (
                        <ValencePage 
                            onFinish={handleValenceFinish}
                            languageData={languageData}
                        />
                    )}
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}> 
                    {showArousal && (
                        <ArousalPage 
                            onFinish={handleArousalFinish}
                            languageData={languageData}
                        />
                    )}
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col></Col>
                <Col xs={12} md={10} lg={8}> 
                    {showRecording && (
                        <RecordVoice 
                            languageData={languageData} 
                            username={username} 
                            identifier={getRecordingIdentifier()} 
                            instructionText={languageData.instructionText2} 
                            medication={null}
                            onFinish={handleRecordingFinish}
                        />
                    )}
                </Col>
                <Col></Col>
            </Row>
        </Container>
    )
}

export default ImagePage